/*
 * <d-predictive-search> — custom predictive search results for the mobile search drawer.
 */
if (typeof SearchForm !== 'undefined' && !customElements.get('d-predictive-search')) {
  class DPredictiveSearch extends SearchForm {
    constructor() {
      super();
      this.cachedResults = {};
      this.results = this.querySelector('[data-predictive-results]');
      this.sectionId = this.dataset.sectionId || 'd-predictive-search';
      this.minChars = parseInt(this.dataset.minChars, 10) || 1;
      this.searchTerm = '';
      this.abortController = new AbortController();
      this.swiper = null;
    }

    connectedCallback() {
      const term = this.getQuery();
      if (term.length >= this.minChars) {
        this.searchTerm = term;
        this.getResults(term);
        const drawer = this.closest('[data-search-drawer]');
        if (drawer) drawer.dataset.hasQuery = 'true';
      }
    }

    getQuery() {
      return this.input.value.trim();
    }

    // SearchForm calls onChange (debounced) on every input event.
    onChange() {
      super.onChange();
      const term = this.getQuery();
      this.searchTerm = term;

      if (term.length < this.minChars) {
        this.clearResults();
        return;
      }
      this.getResults(term);
    }

    onFormReset(event) {
      super.onFormReset(event);
      this.searchTerm = '';
      this.clearResults();
    }

    getResults(term) {
      const key = term.replace(/\s+/g, ' ').toLowerCase();

      if (this.cachedResults[key]) {
        this.render(this.cachedResults[key]);
        return;
      }

      this.setLoading(true);
      this.abortController.abort();
      this.abortController = new AbortController();

      const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=${this.sectionId}&resources[type]=product,collection,query,article,page`;

      fetch(url, { signal: this.abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector(`#shopify-section-${this.sectionId}`);
          const markup = section ? section.innerHTML : '';
          this.cachedResults[key] = markup;
          // Ignore stale responses if the term changed meanwhile.
          if (this.getQuery().toLowerCase() === key) this.render(markup);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') console.error('Predictive search:', error);
        })
        .finally(() => this.setLoading(false));
    }

    render(markup) {
      if (!this.results) return;
      this.results.innerHTML = markup;
    }

    clearResults() {
      if (this.results) this.results.innerHTML = '';
    }

    setLoading(state) {
      this.toggleAttribute('loading', state);
    }
  }

  customElements.define('d-predictive-search', DPredictiveSearch);
}
